import { useMutation, useQueryClient } from 'react-query'
import axios from '../../utils/axios'
import { API_BASE_URL } from '../../constants'

// Hide / restore an analysis in the analysis history list.
//
// Hiding is org-wide and reversible: the AnalysisWrapper row keeps existing and
// simply drops out of the default list, appearing under the "Hidden" chip
// instead (`/analysis/list?hidden=true`).
//
// It is deliberately NOT a delete — AnalysisWrapper is not a soft-delete model,
// so removing one cascades to the customer's FASTQ pair, CNV analysis and VCFs
// with no way back.
export const setAnalysisVisibility = async (analysisId, isHidden) => {
  const { data } = await axios.patch(`${API_BASE_URL}/analysis/${analysisId}/visibility`, {
    is_hidden: isHidden,
  })
  return data
}

export const useSetAnalysisVisibility = () => {
  const queryClient = useQueryClient()
  return useMutation(({ analysisId, isHidden }) => setAnalysisVisibility(analysisId, isHidden), {
    // Refetch rather than patch the cache: the row moves between two different
    // queries (normal list <-> hidden list) and both totals shift, so a local
    // edit would leave one of them stale.
    onSettled: () => queryClient.invalidateQueries('all-analysis'),
  })
}
